import { ref } from 'vue'
import type { NotificationDto } from '~/types'

const pendingNotifications = ref<NotificationDto[]>([])

export const useNotificationToast = () => {
  const push = (notification: NotificationDto) => {
    pendingNotifications.value = [...pendingNotifications.value, notification]
  }

  const pushMany = (notifications: NotificationDto[]) => {
    pendingNotifications.value = [...pendingNotifications.value, ...notifications]
  }

  return { push, pushMany, pendingNotifications }
}
